<p-dialog
  [visible]="blockClientModal()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [closeOnEscape]="true"
  (onHide)="closeDialogEvent()"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '580px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="blockClientFromGroup" (ngSubmit)="blockUnBlockClient()">
      <!-- Content -->
      <div class="surface-0 relative p-3 md:p-4">
        <div
          class="fa fa-times text-xl text-600 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="closeDialogEvent()"
        ></div>

        <div class="text-center">
          <div class="relative inline-block mb-3">
            @if (allClientData && !allClientData.is_blacklisted) {
              <i
                class="fa fa-ban absolute left-0 top-0 p-error text-6xl lg:text-8xl"
              ></i>
            }
            @if (allClientData && allClientData.is_blacklisted) {
              <i
                class="fa fa-check-circle absolute left-0 top-0 text-green-500 text-8xl"
              ></i>
            }

            @if (!allClientData.image) {
              <p-avatar
                [label]="allClientData.full_name | titlecase | shortName"
                shape="circle"
                styleClass="lg:w-6rem lg:h-6rem w-3rem h-3rem text-2xl md:text-3xl"
              />
            }
            @if (allClientData.image) {
              <p-avatar
                [image]="allClientData.image"
                shape="circle"
                styleClass="lg:w-6rem lg:h-6rem w-3rem h-3rem"
              />
            }
          </div>

          <h4 class="text-lg mb-1">
            @if (allClientData && !allClientData.is_blacklisted) {
              <span>{{ 'BLOCK_CLIENT.BLOCK' | translate }}</span>
            }
            @if (allClientData && allClientData.is_blacklisted) {
              <span>{{ 'BLOCK_CLIENT.UNBLOCK' | translate }}</span>
            }
            {{ allClientData.full_name
            }}{{ 'BLOCK_CLIENT.CLIENT_PROFILE' | translate }}
          </h4>
          <p class="text-600 mb-0">
            {{ 'BLOCK_CLIENT.ARE_YOU_SURE_YOU_WANT_TO_BLOCK' | translate }}
            @if (allClientData && !allClientData.is_blacklisted) {
              <span>{{ 'BLOCK_CLIENT.BLOCK' | translate }}</span>
            }
            @if (allClientData && allClientData.is_blacklisted) {
              <span>{{ 'BLOCK_CLIENT.UNBLOCK' | translate }}</span>
            }
            {{ 'BLOCK_CLIENT.THIS_PROFILE' | translate }}
          </p>
        </div>

        <div class="border-bottom-1 border-300 my-4"></div>

        <div class="mb-3">
          @if (
            allClientData &&
            allClientData.full_name &&
            !allClientData.is_blacklisted
          ) {
            <h5
              class="font-medium text-700 text-xs mb-2 block uppercase"
              [innerHTML]="
                'BLOCK_CLIENT.PLEASE_CONFIRM_BLOCK'
                  | translate: { name: allClientData.full_name }
              "
            >
              <!-- {{'BLOCK_CLIENT.PLEASE_CONFIRM' | translate}}{{allClientData.full_name}}
          {{'BLOCK_CLIENT.CAN_BE' | translate}} <span
        *ngIf="!allClientData.is_blacklisted">{{'BLOCK_CLIENT.BLOCKED' | translate}}</span> <span
      *ngIf="allClientData.is_blacklisted">{{'BLOCK_CLIENT.UNBLOCKED' | translate}}</span>{{'BLOCK_CLIENT.ON_THE_BELOW_TEXT_BOX' | translate}} -->
            </h5>
          }
          @if (
            allClientData &&
            allClientData.full_name &&
            allClientData.is_blacklisted
          ) {
            <h5
              class="font-medium text-700 text-xs mb-2 block uppercase"
              [innerHTML]="
                'BLOCK_CLIENT.PLEASE_CONFIRM_UNBLOCK'
                  | translate: { name: allClientData.full_name }
              "
            >
              <!-- {{'BLOCK_CLIENT.PLEASE_CONFIRM' | translate}}{{allClientData.full_name}}
      {{'BLOCK_CLIENT.CAN_BE' | translate}} <span
    *ngIf="!allClientData.is_blacklisted">{{'BLOCK_CLIENT.BLOCKED' | translate}}</span> <span
  *ngIf="allClientData.is_blacklisted">{{'BLOCK_CLIENT.UNBLOCKED' | translate}}</span>{{'BLOCK_CLIENT.ON_THE_BELOW_TEXT_BOX' | translate}} -->
            </h5>
          }
          <input
            type="text"
            pInputText
            placeholder=""
            class="p-inputtext-sm w-full"
            formControlName="confirmationText"
          />
          @if (ConfirmationText.touched && ConfirmationText.invalid) {
            <app-error-msg
              [errors]="ConfirmationText.errors"
              [fieldLabel]="'BLOCK_CLIENT.CONFRIMATION_TEXT' | translate"
            />
          }
        </div>
        @if (allClientData && !allClientData.is_blacklisted) {
          <h5 class="font-medium text-700 text-xs mb-2 block uppercase">
            {{ 'BLOCK_CLIENT.REASON_FOR_BLOCKING' | translate }}
            {{ allClientData.full_name }}
          </h5>
          <textarea
            pInputTextarea
            class="p-inputtext-sm w-full"
            formControlName="confirmationDescription"
          ></textarea>
          @if (
            ConfirmationDescription.touched && ConfirmationDescription.invalid
          ) {
            <app-error-msg
              [errors]="ConfirmationDescription.errors"
              [fieldLabel]="'BLOCK_CLIENT.CONFRIMATION_DESCRIPTION' | translate"
            />
          }
        }
      </div>
      <!-- Content -->

      <!-- Content -->
      <div class="surface-100 p-4">
        <ol class="list-decimal text-xs text-600 m-0">
          <li class="my-1">{{ 'BLOCK_CLIENT.CONTENT_LINE_1' | translate }}</li>
          <li class="my-1">{{ 'BLOCK_CLIENT.CONTENT_LINE_2' | translate }}</li>
          <li class="my-1">{{ 'BLOCK_CLIENT.CONTENT_LINE_3' | translate }}</li>
          <li class="my-1">{{ 'BLOCK_CLIENT.CONTENT_LINE_4' | translate }}</li>
          <li class="my-1">{{ 'BLOCK_CLIENT.CONTENT_LINE_5' | translate }}</li>
        </ol>
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div class="lg:px-4 px-2 py-3 border-top-1 border-400 surface-0">
        <div class="flex align-items-center justify-content-between">
          <div class="w-4">
            <p-button
              type="button"
              [label]="'BLOCK_CLIENT.CANCEL' | translate"
              styleClass="p-button-link text-sm"
              (click)="closeDialogEvent()"
            />
          </div>
          <div class="w-8 text-right">
            <p-button
              type="submit"
              [label]="'BLOCK_CLIENT.CONTINUE' | translate"
              [loading]="btnLoading"
              [styleClass]="
                allClientData && allClientData.is_blacklisted
                  ? 'text-sm  p-button-success'
                  : 'text-sm  p-button-danger'
              "
              [disabled]="!blockClientFromGroup.valid"
            />
          </div>
        </div>
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
